const status = [
    {text: 'settlements.status.inProgress', value: 'IN_PROGRESS'},
    {text: 'settlements.status.completed', value: 'COMPLETED'},
    {text: 'settlements.status.sentToSponsor', value: 'SENT_TO_SPONSOR'},
    {text: 'settlements.status.rejectedBySponsor', value: 'REJECTED_BY_SPONSOR'},
    {text: 'settlements.status.approvedBySponsor', value: 'APPROVED_BY_SPONSOR'},
    {text: 'settlements.status.error', value: 'ERROR'}
]

const orderBy = [
    {
        text: 'home.order.createdAt',
        value: 'createdAt',
        order: 'desc'
    },
    {
        text: 'home.order.beneficiaryName',
        value: 'beneficiaryName',
        order: 'asc'
    },
]

const currencySymbols = [
    {
        code: "DOP",
        symbol: "$"
    }
]

const mimeTypes = ["image/png", "image/jpeg", "application/xml", "text/xml", "application/pdf"]

const sponsorsWithOnDemand = ['do-universal', 'do-primera', 'do-humano'];




export {
    status,
    orderBy,
    currencySymbols,
    mimeTypes,
    sponsorsWithOnDemand
}